import { render, staticRenderFns } from "./showFinishPaper.vue?vue&type=template&id=1299608b&scoped=true&"
import script from "./showFinishPaper.vue?vue&type=script&lang=js&"
export * from "./showFinishPaper.vue?vue&type=script&lang=js&"
import style0 from "./showFinishPaper.vue?vue&type=style&index=0&id=1299608b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299608b",
  null
  
)

export default component.exports